import script from "./ScrollToTop.vue?vue&type=script&setup=%7Bname%3AScrollToTop%7D&lang=ts"
export * from "./ScrollToTop.vue?vue&type=script&setup=%7Bname%3AScrollToTop%7D&lang=ts"

const __exports__ = script;

export default __exports__